<template>
  <v-chip :color="statusData.color" small :dark="statusData.dark">
    {{ statusData.name }}
  </v-chip>
</template>

<script>
export default {
  name: "StatusStudy",
  props: {
    statusStudy: Number
  },
  data() {
    return {
        statusData: {color: "gray", name: "No definido", status: 0, dark: false}
    };
  },
  watch:{
    statusStudy(){
        this.statusData = this.$utilFront.getStatusStudy(this.statusStudy);
    }
  },
  mounted(){
    this.statusData = this.$utilFront.getStatusStudy(this.statusStudy);
  }
  
};
</script>
